export const humanize = (str) =>
  str ? String(str).replaceAll("_", " ").trim() : "";

// New: derive metadata directly from an array of section definitions
export function deriveMetadataFromSections(sections) {
  const names = Array.isArray(sections)
    ? sections.map((s) => s && s.section).filter((name) => Boolean(name))
    : [];
  return {
    name: names.length ? humanize(names[0]) : "Form",
    description: "Form configuration derived from sections",
    subSteps: names.length || 1,
    subStepNames: names.map(humanize),
    subStepSections: names,
  };
}

export function getFieldsForSection({ schema, sectionKey }) {
  if (!Array.isArray(schema) || !sectionKey) return [];
  const section = schema.find((s) => s && s.section === sectionKey);
  return Array.isArray(section?.fields) ? section.fields : [];
}

// Note: buildSectionDataForSection removed as unused

// Helper: expand field names for special types (e.g., single_address, multi_boolean_choice with nested fields)
export function expandSectionFieldNames(fieldsDef) {
  const names = [];
  (fieldsDef || []).forEach((f) => {
    const field = typeof f === "string" ? { name: f } : f || {};
    if (field.type === "single_address") {
      // Count errors on subfields that are actually validated by Zod/RHF
      names.push("address", "city", "stateAddress", "zipCode");
    } else if (field.type === "multi_boolean_choice" && field.fields && Array.isArray(field.fields)) {
      // For multi_boolean_choice, include the parent field name
      // The nested fields are validated as part of the parent field's structure
      // The error path is like ["fields", "exchanges"] which means we validate the parent
      names.push(field.name);
    } else if (field.name) {
      names.push(field.name);
    }
  });
  return names;
}
